// src/utils/emailService.js
import emailjs from 'emailjs-com';

export const sendEmail = (templateParams, templateId) => {
  return emailjs.send(
    'service_4qip7ai',
    "template_yeknh08",
    templateParams,
    'cIbrykxwORJCM8Tvz'
  );
};
